import styled, { css } from 'styled-components';

import IdCornersGuide from 'inquiry/components/ScannerOverlay/IdCornersGuide';

const Positioner = styled('div')<{ mirrored: boolean }>`
  ${({ mirrored }) =>
    mirrored &&
    css`
      transform: scale(-1, 1);
    `};
  width: 100%;
`;

const SimpleGuide = styled('div')`
  padding-bottom: 65.97%;
  width: 100%;
`;

interface IdCornersOnlyGuideProps {
  mirrored?: boolean;
  hideGuide?: boolean;
  highlightCorners?: boolean;
}

export default function IdCornersOnlyGuide({
  mirrored = false,
  highlightCorners = false,
}: IdCornersOnlyGuideProps) {
  return (
    <Positioner data-test='id-corners-guide' mirrored={mirrored}>
      <div style={{ position: 'relative' }}>
        <IdCornersGuide highlightCorners={highlightCorners} />
        <SimpleGuide />
      </div>
    </Positioner>
  );
}
